// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  fusionUrl: 'http://61.162.43.9:18081/',
  touristToken: '0000-0000',
  Stomp: {
    brokerURL: 'ws://58.56.164.66:16674/ws',
    login: 'test',
    passcode: 'test',
    host: 'oms_vhost'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
